module.exports = __webpack_public_path__ + "9bfd0a2495707ecb76047068e1ab33e6.MP3";